import React from "react";
import "./styles/Information.css";
import Footer from "../components/Footer";
import { connect } from "react-redux";
import exchangeIcon from "../assets/intercambios.svg";

const CONTENT = {
  es: {
    title: "¿Qué es Intercambiar?",
    paragraphs: [
      "El Intercambio es el traspaso de bienes materiales o de servicios por otros objetos o servicios, y se diferencia de la compraventa habitual en que no intermedia el dinero como representante del valor en la transacción. Antiguamente se lo llamaba trueque.",
      "El intercambio solo se produce si ambas partes valoran más subjetivamente aquello que tiene la otra que lo que esperan dar a cambio. Así, supongamos que Juan tiene A, y Marcos tiene B. Solo si Juan valora más B que A, y Marcos valora más A que B, se realizará el intercambio (o esto es, por lo menos, una condición necesaria para que se produzca).",
      "El sitio provee la posibilidad de publicar anuncios de los oferentes (usuarios registrados que desean y publican intercambiar) de algún intercambio que deseen realizar, así el o los demandantes (usuarios registrados que desean intercambiar) podrán negociar hasta llegar a algún acuerdo.",
      "Godiway solo realiza el vínculo entre ambas partes, oferentes y demandantes; la negociación que realicen y acuerden queda entre ellos.",
      "El precio al que llegarán ambas partes para efectuar el intercambio depende de sus valoraciones subjetivas. En efecto, el precio máximo al que está dispuesto a pagar el comprador debe ser mayor que el precio mínimo al que está dispuesto a vender el vendedor.",
    ],
  },
  en: {
    title: "What is Exchanging?",
    paragraphs: [
      "Exchange is the transfer of material goods or services for other objects or services, and differs from the usual sale and purchase in that money does not act as the representative of value in the transaction. Formerly it was called barter.",
      "The exchange only occurs if both parties value more subjectively what the other has than what they expect to give back in exchange. So suppose that John has A, and Marcos has B. Only if John values B more than A, and Marcos values A more than B, will the exchange take place (this being, at least, a necessary condition for it to occur).",
      "The site provides the possibility of publishing announcements from the bidders (registered users who want and publish exchanges) of any exchange they want to make, so that the claimants (registered users who want to exchange) may negotiate until an agreement is reached.",
      "Godiway only makes the link between both offering and claiming parties; the negotiation they carry out and agree upon remains among them.",
      "The price at which both parties will arrive to carry out the exchange depends on their subjective assessments. Indeed, the maximum price the buyer is willing to pay must be greater than the minimum price at which the seller is willing to sell.",
    ],
  },
};

class WhatIsExchange extends React.Component {
  render() {
    const content = this.props.lang === "es" ? CONTENT.es : CONTENT.en;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="container-information">
            <div className="info-card">
              <div className="info-card__header">
                <span className="info-card__icon">
                  <img src={exchangeIcon} alt="" aria-hidden="true" />
                </span>
                <h1 className="info-card__title">{content.title}</h1>
              </div>
              <div className="info-card__body">
                {content.paragraphs.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    lang: reducer.i18n.locale,
  };
}

export default connect(mapStateToProps, null)(WhatIsExchange);
